import React, { useMemo } from 'react';
import List from '@material-ui/core/List';
import { makeStyles, Theme } from '@material-ui/core/styles';
import Pagination from 'components/pagination/Pagination';
import CustomerListItem from './CustomerListItem';
import { usePagination } from 'providers/pagination';
import { Customer } from 'types/customer';
import { useListStyle } from 'providers/listStyle';

type Styles = {
  listStyle: string;
};

const styles = makeStyles<Theme, Styles>(theme => ({
  list: props => ({
    display: 'grid',
    gridTemplateColumns: props.listStyle === 'grid' ? 'repeat(auto-fill, minmax(400px, 1fr))' : '1fr',
    gridAutoRows: 'min-content',
    gap: '10px',
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: props.listStyle === 'grid' ? 'repeat(auto-fill, minmax(300px, 1fr))' : '1fr',
    },
  }),
}));

interface CustomersTableProps {
  customers: Customer[];
}

type PaginationValues = {
  start: number;
  end: number;
};

const CustomerList: React.FC<CustomersTableProps> = ({ customers }) => {
  const { listStyle } = useListStyle();
  const classes = styles({ listStyle });
  const { rowsPerPage, page } = usePagination();

  const pagination = useMemo((): PaginationValues => {
    return {
      start: page * rowsPerPage,
      end: page * rowsPerPage + rowsPerPage,
    };
  }, [page, rowsPerPage]);

  return (
    <>
      <List className={classes.list} disablePadding>
        {customers.slice(pagination.start, pagination.end).map(customer => (
          <CustomerListItem customer={customer} key={customer.id} />
        ))}
      </List>
      <Pagination count={customers.length} />
    </>
  );
};

export default CustomerList;
